/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import dayjs from 'dayjs';
import { func, shape, string } from 'prop-types';
import {
  monthlyRetainerLimit,
  monthlyRetainerLimitInString,
  revShareLimit,
  revShareThresholdLimit,
  revShareThresholdLimitInString,
  monthlyRetainerLimitWalmart,
  monthlyRetainerLimitInStringWalmart,
  revShareLimitWalmart,
  revShareThresholdLimitWalmart,
  revShareThresholdLimitInStringWalmart,
  ONEP,
  HYBRID,
  THREEP,
  SELLER,
  VENDOR,
} from '../../../constants';

export default function AgreementAprovalConditions({
  formData,
  newAddendumData,
  setApprovalCondition,
  selectedCurrency,
}) {
  const monthlyRetainerLimitValue =
    formData?.channel?.value === 'amazon'
      ? monthlyRetainerLimit
      : monthlyRetainerLimitWalmart;
  const revShareLimitValue =
    formData?.channel?.value === 'amazon'
      ? revShareLimit
      : revShareLimitWalmart;

  const revShareThresholdLimitValue =
    formData?.channel?.value === 'amazon'
      ? revShareThresholdLimit
      : revShareThresholdLimitWalmart;

  const monthlyRetainerLimitStringValue =
    formData?.channel?.value === 'amazon'
      ? monthlyRetainerLimitInString
      : monthlyRetainerLimitInStringWalmart;

  const revShareThresholdLimitStringValue =
    formData?.channel?.value === 'amazon'
      ? revShareThresholdLimitInString
      : revShareThresholdLimitInStringWalmart;

  // check conditions for retainer values
  const checkCondition = (
    retainerObject,
    accountType,
    period,
    valueLimit,
    valueLimitInString,
    feeTypeStr,
  ) => {
    const retainerArray = [];
    Object.entries(retainerObject).forEach(([key, value]) => {
      if (Number(value) < valueLimit) retainerArray.push(key?.split(' ')[0]);
    });
    if (retainerArray.length)
      return `${accountType} ${feeTypeStr} has ${retainerArray.join(
        ', ',
      )} ${period} value less than ${selectedCurrency}${valueLimitInString}.`;
    return null;
  };

  // check Approval Conditions
  useEffect(() => {
    const approvalConditionsTemp = [];
    const feeStructureTemp = formData?.fee_structure;
    const sellerField = formData?.fee_structure_seller_type;
    const vendorField = formData?.fee_structure_vendor_type;
    const sellerOrHybrid = [SELLER, ONEP, HYBRID].includes(
      formData?.seller_type?.value,
    );
    const vendorOrHybrid = [VENDOR, THREEP, HYBRID].includes(
      formData?.seller_type?.value,
    );
    const contractLengthTemp = Number(
      formData?.length?.value?.match(/(\d+)/)?.[0],
    );
    if (contractLengthTemp < 6) {
      approvalConditionsTemp.push(
        'This Agreement length is less than 6 months.',
      );
    }
    if (formData?.is_dynamic_dsp_fee) {
      if (
        (formData?.dsp_fee && Number(formData?.dsp_fee) < 10000) ||
        (formData?.dsp_fee && Number(formData?.dsp_fee_second) < 10000) ||
        (formData?.dsp_fee && Number(formData?.dsp_fee_third) < 10000)
      ) {
        //   approvalConditionsTemp.push(
        //     `DSP monthly budget is less than ${selectedCurrency}10,000, `,
        //   );
        // } else {
        let message = `DSP monthly budget is less than ${selectedCurrency}10,000`;
        if (formData?.dsp_fee && Number(formData?.dsp_fee) < 10000) {
          message += `, for ${dayjs(
            formData?.dsp_marketplaces?.[0]?.monthly_budget_date,
          ).format('MMMM')} at ${selectedCurrency}${formData?.dsp_fee}`;
        }
        if (
          formData?.dsp_fee_second &&
          Number(formData?.dsp_fee_second) < 10000
        ) {
          message += `, for ${dayjs(
            formData?.dsp_marketplaces?.[0]?.monthly_budget_second_date,
          ).format('MMMM')} at ${selectedCurrency}${formData?.dsp_fee_second}`;
        }
        if (
          formData?.dsp_fee_third &&
          Number(formData?.dsp_fee_third) < 10000
        ) {
          message += `, for ${dayjs(
            formData?.dsp_marketplaces?.[0]?.monthly_budget_third_date,
          ).format('MMMM')} at ${selectedCurrency}${formData?.dsp_fee_third}`;
        }
        message += '.';
        approvalConditionsTemp.push(message);
      }
    } else if (formData?.dsp_fee && Number(formData?.dsp_fee) < 10000) {
      approvalConditionsTemp.push(
        `DSP monthly budget is less than ${selectedCurrency}10,000.`,
      );
    }

    if (formData?.agency_fee < 15) {
      approvalConditionsTemp.push('Agency fees is less than 15%.');
    }
    if (newAddendumData?.addendum && newAddendumData?.addendum !== '<p></p>') {
      approvalConditionsTemp.push('This Agreement has addendum.');
    }
    if (feeStructureTemp?.[sellerField]?.billing_cap) {
      approvalConditionsTemp.push(`${sellerField} has a billing cap.`);
    }
    if (feeStructureTemp?.[vendorField]?.billing_cap) {
      approvalConditionsTemp.push(`${vendorField} has a billing cap.`);
    }
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      Number(feeStructureTemp?.[sellerField]?.rev_share) < revShareLimitValue
    ) {
      approvalConditionsTemp.push(
        `${sellerField} revenue share is less than ${revShareLimitValue}.`,
      );
    }
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      Number(feeStructureTemp?.[vendorField]?.rev_share) < revShareLimitValue
    ) {
      approvalConditionsTemp.push(
        `${vendorField} revenue share is less than ${revShareLimitValue}.`,
      );
    }
    // check for monthly retainer start
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.monthly_retainer &&
      Number(feeStructureTemp?.[sellerField]?.monthly_retainer) <
        monthlyRetainerLimitValue
    ) {
      approvalConditionsTemp.push(
        `${sellerField} retainer is less than ${selectedCurrency}${monthlyRetainerLimitStringValue}.`,
      );
    }
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.monthly_retainer &&
      Number(feeStructureTemp?.[vendorField]?.monthly_retainer) <
        monthlyRetainerLimitValue
    ) {
      approvalConditionsTemp.push(
        `${vendorField} retainer is less than ${selectedCurrency}${monthlyRetainerLimitStringValue}.`,
      );
    }
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.quarterly_monthly_retainer
    ) {
      const quartelyConditionSeller = checkCondition(
        feeStructureTemp?.[sellerField]?.quarterly_monthly_retainer,
        sellerField,
        'quarterly',
        monthlyRetainerLimitValue,
        monthlyRetainerLimitStringValue,
        'retainer',
      );
      if (quartelyConditionSeller)
        approvalConditionsTemp.push(quartelyConditionSeller);
    }
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.quarterly_monthly_retainer
    ) {
      const quartelyConditionVendor = checkCondition(
        feeStructureTemp?.[vendorField]?.quarterly_monthly_retainer,
        vendorField,
        'quarterly',
        monthlyRetainerLimitValue,
        monthlyRetainerLimitStringValue,
        'retainer',
      );
      if (quartelyConditionVendor)
        approvalConditionsTemp.push(quartelyConditionVendor);
    }
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.monthly_monthly_retainer
    ) {
      const monthlyConditionSeller = checkCondition(
        feeStructureTemp?.[sellerField]?.monthly_monthly_retainer,
        sellerField,
        'Months',
        monthlyRetainerLimitValue,
        monthlyRetainerLimitStringValue,
        'retainer',
      );
      if (monthlyConditionSeller)
        approvalConditionsTemp.push(monthlyConditionSeller);
    }
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Retainer Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.monthly_monthly_retainer
    ) {
      const monthlyConditionVendor = checkCondition(
        feeStructureTemp?.[vendorField]?.monthly_monthly_retainer,
        vendorField,
        'Months',
        monthlyRetainerLimitValue,
        monthlyRetainerLimitStringValue,
        'retainer',
      );
      if (monthlyConditionVendor)
        approvalConditionsTemp.push(monthlyConditionVendor);
    }
    // check for monthly retainer end

    // check for revenue share threshold limit - start here
    // checking seller sales threshold
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.sales_threshold &&
      Number(feeStructureTemp?.[sellerField]?.sales_threshold) <
        revShareThresholdLimitValue
    ) {
      approvalConditionsTemp.push(
        `${sellerField} threshold is less than ${selectedCurrency}${revShareThresholdLimitStringValue}.`,
      );
    }

    // checking vendor sales threshold
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.sales_threshold &&
      Number(feeStructureTemp?.[vendorField]?.sales_threshold) <
        revShareThresholdLimitValue
    ) {
      approvalConditionsTemp.push(
        `${vendorField} threshold is less than ${selectedCurrency}${revShareThresholdLimitStringValue}.`,
      );
    }

    // checking seller quarterly threshold
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.quarterly_rev_share
    ) {
      const quartelyConditionSeller = checkCondition(
        feeStructureTemp?.[sellerField]?.quarterly_rev_share,
        sellerField,
        'quarterly',
        revShareThresholdLimitValue,
        revShareThresholdLimitStringValue,
        'rev share',
      );
      if (quartelyConditionSeller)
        approvalConditionsTemp.push(quartelyConditionSeller);
    }

    // checking vendor quarterly threshold
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.quarterly_rev_share
    ) {
      const quartelyConditionVendor = checkCondition(
        feeStructureTemp?.[vendorField]?.quarterly_rev_share,
        vendorField,
        'quarterly',
        revShareThresholdLimitValue,
        revShareThresholdLimitStringValue,
        'rev share',
      );
      if (quartelyConditionVendor)
        approvalConditionsTemp.push(quartelyConditionVendor);
    }

    // checking seller monthly threshold
    if (
      (feeStructureTemp?.[sellerField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[sellerField]?.fee_type ===
          'Retainer + % Rev Share') &&
      sellerOrHybrid &&
      feeStructureTemp?.[sellerField]?.monthly_rev_share
    ) {
      const monthlyConditionSeller = checkCondition(
        feeStructureTemp?.[sellerField]?.monthly_rev_share,
        sellerField,
        'Months',
        revShareThresholdLimitValue,
        revShareThresholdLimitStringValue,
        'rev share',
      );
      if (monthlyConditionSeller)
        approvalConditionsTemp.push(monthlyConditionSeller);
    }

    // checking vendor monthly threshold
    if (
      (feeStructureTemp?.[vendorField]?.fee_type === 'Revenue Share Only' ||
        feeStructureTemp?.[vendorField]?.fee_type ===
          'Retainer + % Rev Share') &&
      vendorOrHybrid &&
      feeStructureTemp?.[vendorField]?.monthly_rev_share
    ) {
      const monthlyConditionVendor = checkCondition(
        feeStructureTemp?.[vendorField]?.monthly_rev_share,
        vendorField,
        'Months',
        revShareThresholdLimitValue,
        revShareThresholdLimitStringValue,
        'rev share',
      );
      if (monthlyConditionVendor)
        approvalConditionsTemp.push(monthlyConditionVendor);
    }
    // check for revenue share threshold limit - end here

    if (formData?.contract_addendum?.length) {
      approvalConditionsTemp.push('This agreement has draft addendum.');
    }
    if (feeStructureTemp?.[sellerField]?.fee_type === 'Retainer Only') {
      approvalConditionsTemp.push(`${sellerField} is of type Retainer Only.`);
    }
    if (feeStructureTemp?.[vendorField]?.fee_type === 'Retainer Only') {
      approvalConditionsTemp.push(`${vendorField} is of type Retainer Only.`);
    }

    setApprovalCondition(approvalConditionsTemp);
  }, [
    formData,
    newAddendumData,
    formData.fee_structure,
    setApprovalCondition,
    selectedCurrency,
  ]);

  return null;
}

AgreementAprovalConditions.defaultProps = {
  formData: {},
  newAddendumData: {},
  setApprovalCondition: () => {},
  selectedCurrency: '$ (USD)',
};

AgreementAprovalConditions.propTypes = {
  formData: shape({}),
  newAddendumData: shape({}),
  setApprovalCondition: func,
  selectedCurrency: string,
};
